module.exports = __webpack_public_path__ + "static/media/institutions-3.df7af8a7.png";